import React from 'react';

const HeroSection = ({ title, subtitle, description, ctaText, ctaAction, backgroundImage, children }) => {
  return (
    <section 
      className="relative min-h-[60vh] flex items-center justify-center bg-gradient-to-r from-aug-blue to-aug-green text-white"
      style={backgroundImage ? {
        backgroundImage: `linear-gradient(rgba(30, 90, 142, 0.8), rgba(45, 122, 92, 0.8)), url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      } : {}}
      data-testid="hero-section"
    >
      <div className="max-w-[1400px] mx-auto px-xl py-4xl text-center">
        {title && (
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
            {title}
          </h1>
        )}
        {subtitle && (
          <p className="text-xl md:text-2xl mb-6 text-aug-blue-light">
            {subtitle}
          </p>
        )}
        {description && (
          <p className="text-base md:text-lg max-w-3xl mx-auto mb-8 leading-relaxed">
            {description}
          </p>
        )}
        {ctaText && ctaAction && (
          <button
            onClick={ctaAction}
            className="bg-white text-aug-blue px-8 py-4 rounded-xl font-semibold text-lg hover:bg-aug-cream transition-all duration-300 shadow-lg hover:shadow-xl"
            data-testid="hero-cta-button"
          >
            {ctaText}
          </button>
        )}
        {children}
      </div>
    </section>
  );
};

export default HeroSection;